import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgBackBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.98,
    height: 16,
    viewBox: "0 0 15.98 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.1 7.493a1.332 1.332 0 01.28-.44L7.041.392a1.338 1.338 0 011.892 1.892l-4.4 4.383h10.115a1.332 1.332 0 110 2.664H4.536l4.4 4.383a1.338 1.338 0 11-1.895 1.89L.38 8.945A1.377 1.377 0 01.1 7.493z",
    fill: "#202124"
  })));
}

export { SvgBackBtn as ReactComponent };
//# sourceMappingURL=BackBtn.svg.js.map
